import{
    CREATE_CLIENT_ERROR,
    CREATE_CLIENT_SUCCESS,
    DELETE_CLIENT_ERROR,
    DELETE_CLIENT_SUCCESS,
    FETCH_CLIENTS_ERROR,
    FETCH_CLIENTS_SUCCESS,
    UPDATE_CLIENT_ERROR,
    UPDATE_CLIENT_SUCCESS

} from './types';
const initialState = {
    loading: false,
    data: [],
    error: "",
  };
  export default function clientReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CLIENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          data: [...action.payload],
          error: "",
        };
      case FETCH_CLIENTS_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
  
      case CREATE_CLIENT_SUCCESS:
        return {
          ...state,
          data: [...state.data, action.payload],
          loading: false,
          error: "",
        };
      case CREATE_CLIENT_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_CLIENT_SUCCESS:
        return {
          ...state,
          data: [
            ...state.data.map((client) => {
              if (client.id === action.payload.id) return action.payload;
              else return client;
            }),
          ],
          loading: false,
          error: "",
        };
      case UPDATE_CLIENT_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
      case DELETE_CLIENT_SUCCESS:
        return {
          ...state,
          loading: false,
          data: [
            ...state.data.filter((client) => client.id !== action.payload),
          ],
          error: "",
        };
      case DELETE_CLIENT_ERROR:
        return {
          ...state,
          data: [],
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
}